import { render, staticRenderFns } from "./PRCardView.vue?vue&type=template&id=6705d814&scoped=true"
import script from "./PRCardView.vue?vue&type=script&lang=js"
export * from "./PRCardView.vue?vue&type=script&lang=js"
import style0 from "./PRCardView.vue?vue&type=style&index=0&id=6705d814&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6705d814",
  null
  
)

export default component.exports